export default "__VITE_ASSET__CNtCpv$d__"